import { createContext, useContext } from "react";
import type { useRadioController } from "./useRadioController";

export type RadioController = ReturnType<typeof useRadioController>;
export const RadioLiveContext = createContext<RadioController | null>(null);

/** All controls share the shell's persistent, authorized site connection. */
export function useRadioLive(args: {
  channelId: string | null;
  siteId: string | null;
  listenOnly?: boolean;
}) {
  const radio = useContext(RadioLiveContext);
  if (!radio) throw new Error("Radio controls must be inside the app Radio provider");
  const matches = args.siteId === radio.state.siteId;
  return {
    ...radio,
    canTransmit: matches && radio.canTransmit,
    startRadioTransmission: matches ? radio.startRadioTransmission : async () => {},
  };
}